








































import { Component, Vue, Emit, Prop, Watch } from 'vue-property-decorator';
import EscalatedAlertTable from './escalated-alert-table.vue';
import CircularProgress from './circle-progress.vue';
import { EscalatedAlertApiService } from '@/services/escalated-alert-service';
import Toast from '@/components/display/toast.vue';
import { EscalatedAlert, EscalatedAlertCounts } from '@/api';

@Component({
	components: {
		CircularProgress,
		EscalatedAlertTable,
	},
})
export default class EscalatedAlertTableTab extends Vue {
	// API / API management & return fields
	public escalatedAlertApi: EscalatedAlertApiService = new EscalatedAlertApiService();
	public toast: Toast = new Toast();
	public alerts: EscalatedAlert[] = [];
	public loading: boolean = false;
	public failure: boolean = false;

	// Pagination Fields
	public currentPage: number = 1;
	public totalRows: number = 0;

	public badges: EscalatedAlertCounts | null = null;

	// Tab management fields to conserve tab selection data update
	public tabIndex: number = 0;
	@Prop({ required: true, type: Number })
	public tabIndexIn!: number;

	public get pageStatus(): string {
		switch (this.tabIndex) {
			case 0:
				return 'new';
			case 1:
				return 'monitor';
			case 2:
				return 'escalated';
			case 3:
				return 'resolved';
			default:
				return 'new';
		}
	}

	public get perPage(): int {
		switch (this.tabIndex) {
			case 3: // resolved
				return 15;
			default:
				return 50;
		}
	}

	public sort(): string {
		switch (this.tabIndex) {
			case 0:
				return 'created_at';
			case 1:
			case 2:
			case 3:
			default:
				return '-updated_at';
		}
	}

	@Watch('tabIndex')
	public resetCurrentPage() {
		this.currentPage = 1;
	}

	@Watch('tabIndex')
	@Watch('currentPage')
	public async loadEscalatedAlerts() {
		this.loading = true;
		const { escalatedAlerts, errorMessage } = await this.escalatedAlertApi.getEscalatedAlerts({
			params: { include: 'product, event, logs, entity.currententitystate', "filter[status]": this.pageStatus, perPage: this.perPage, page: this.currentPage, sort: this.sort() },
		});

		if (escalatedAlerts != null) {
			this.alerts = escalatedAlerts.data ?? [];
			this.totalRows = escalatedAlerts.meta.total;
			this.failure = false;
		} else if (errorMessage) {
			this.failure = true;
			this.alerts = [];
			this.toast.makeToast(errorMessage, 'Escalated Alerts Error', 'danger');
		}
		this.loading = false;
	}

	public async loadEscalatedAlertsCounts() {
		const { escalatedAlertsCounts, errorMessage } = await this.escalatedAlertApi.getEscalatedAlertsCounts();

		if (escalatedAlertsCounts != null) {
			this.badges = escalatedAlertsCounts;
		} else if (errorMessage) {
			this.toast.makeToast(errorMessage, 'Escalated Alerts Error', 'danger');
		}
	}

	public handleReload() {
		this.loadEscalatedAlerts();
		this.loadEscalatedAlertsCounts();
	}

	public async mounted() {
		this.tabIndex = this.tabIndexIn;
		this.loadEscalatedAlerts();
		this.loadEscalatedAlertsCounts();
	}

	@Emit('alert-selection')
	public handleTablePress(alert: EscalatedAlert) {
		return alert;
	}

	@Emit('tab-change')
	public handleTabChange() {
		return this.tabIndex;
	}

	public beforeDestroy() {
		clearInterval(this.interval);
	}
}
